import DeleteIcon from "@mui/icons-material/Delete";
import { Grid, IconButton, Stack } from "@mui/material";
import { FormikDecimalTextField } from "@shared";
import { FormikProps } from "formik";

import { FormikAutocomplete } from "@/common/components/fields/formik/formik-autocomplete/FormikAutocomplete";
import { FormikDatePicker } from "@/common/components/fields/formik/formik-date-picker/FormikDatePicker";
import { CounselorWorkTimeFormValues } from "@/pages/system-settings/tabs/counselors/pages/counselor-detail/pages/work-time/CounselorWorkTime.types";
import { useTranslation } from "@/translations";

interface Props {
  formik: FormikProps<CounselorWorkTimeFormValues>;
  index: number;
  workAreaOptions: string[];
  teamOptions: string[];
  onDelete: () => void;
}

export function WorkTimeAllocationRow({ formik, index, workAreaOptions, teamOptions, onDelete }: Props) {
  const { t } = useTranslation();

  return (
    <Stack direction={{ xs: "column", lg: "row" }} gap={2} alignItems="flex-start">
      <Grid container spacing={2} sx={{ flex: 1, width: "100%" }}>
        <Grid size={{ xs: 12, lg: 2.5 }}>
          <FormikAutocomplete
            formik={formik}
            path={`allocations.${index}.workArea`}
            label={t("counselors.workTime.allocation.workArea")}
            options={workAreaOptions}
            required
          />
        </Grid>
        <Grid size={{ xs: 12, lg: 2.5 }}>
          <FormikAutocomplete
            formik={formik}
            path={`allocations.${index}.team`}
            label={t("counselors.workTime.allocation.team")}
            options={teamOptions}
            required
          />
        </Grid>
        <Grid size={{ xs: 6, lg: 2.5 }}>
          <FormikDatePicker
            formik={formik}
            path={`allocations.${index}.validFrom`}
            label={t("counselors.workTime.allocation.validFrom")}
            required
          />
        </Grid>
        <Grid size={{ xs: 6, lg: 2.5 }}>
          <FormikDatePicker
            formik={formik}
            path={`allocations.${index}.validTo`}
            label={t("counselors.workTime.allocation.validTo")}
            clearable
          />
        </Grid>
        <Grid size={{ xs: 12, lg: 2 }}>
          <FormikDecimalTextField
            formik={formik}
            path={`allocations.${index}.hours`}
            label={t("counselors.workTime.allocation.hoursPerWeek")}
            minValue={0}
            required
          />
        </Grid>
      </Grid>
      <IconButton
        onClick={onDelete}
        size="medium"
        color="default"
        aria-label={t("counselors.workTime.allocation.deleteRow")}
      >
        <DeleteIcon />
      </IconButton>
    </Stack>
  );
}
